import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { StepService as StepService } from '../services/step.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-step-container',
  templateUrl: './step-container.component.html',
  styleUrls: ['./step-container.component.scss'],
})
export class StepContainerComponent implements OnInit, AfterViewInit {
  private _step: number;
  hasScrollbar = false;
  maxStep: number;

  @ViewChild('scrollable') scrollableElement: ElementRef;
  @ViewChild('scrollShadow') scrollShadowElement: ElementRef;

  constructor(
    private stepService: StepService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.stepService.stepChange$.subscribe(stepNumber => (this.step = stepNumber));

    this.step = this.stepService.getActiveStep();
    this.maxStep = this.stepService.maxStep;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollHelpers();
    });
  }

  get step(): number {
    return this._step;
  }

  set step(value: number) {
    this._step = value;
    if (this.scrollableElement) {
      this.scrollableElement.nativeElement.scrollTop = 0;
    }
  }

  get stepTitle(): string {
    return this.translateService.instant(`${this.stepService.stepName(this.step)}.TITLE`);
  }

  scrollHelpers() {
    if (this.scrollableElement && this.scrollShadowElement) {
      const target = this.scrollableElement.nativeElement as HTMLDivElement;
      const scrollShadow = this.scrollShadowElement.nativeElement as HTMLDivElement;

      this.hasScrollbar = Math.round(target.clientHeight) !== Math.round(target.scrollHeight);
      const shadowOffset = Math.min(0, target.scrollTop - scrollShadow.scrollHeight);

      scrollShadow.style.transform = `translateY(${shadowOffset}px)`;
    }
  }
}
